import React from "react";
import "./index.css";

const Collection = ({ collection, addPostToCollection }) => {
  return (
    <div
      className={`collection ${collection.containsPost && "-disabled"}`}
      onClick={() => (!collection.containsPost ? addPostToCollection(collection._id) : null)}
    >
      {collection.containsPost && <div className="overlay" />}
      <span className="name">{collection.name}</span>
      <span className="count">{collection.postsCount} cases</span>
    </div>
  );
};

export default Collection;



// WEBPACK FOOTER //
// ./src/components/AddToCollectionModal/components/Collection/index.js